import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/internal/operators/catchError'
import { map } from 'rxjs/operators';
import { AdobeLaunchService } from 'src/app/services/adobe-launch.service'
import { FiltersService } from 'src/app/services/filtersService.service'
import { Constants } from 'src/assets/constants'

import { FundDetails } from '../../../models/fund-details.model'

const PAGE_SIZE = Constants.PAGE_SIZE

@Component({
  selector: 'VFA-results',
  templateUrl: './results.component.html',
  styleUrls: ['./results.component.scss'],
})
export class ResultsComponent implements OnInit {
  public annualReturnsDate: Date
  public ytdAsOfDate: Date
  public priceAsOfDate: Date
  public page: number
  public PAGE_SIZE: number
  public activeTab: number
  filterBy = ''
  switchModel: boolean
  disableSwitch = false
  public data$: Observable<FundDetails>
  public isDataLoaded = true
	viewSwitch = true
  @Output() detailedViewValue = new EventEmitter<boolean>()
  @Output() openFilterValue = new EventEmitter<boolean>()
  constructor(
    private readonly route: ActivatedRoute,
    private readonly filtersService: FiltersService,
    public adobeLaunchService: AdobeLaunchService,
  ) {}
  @Input() closeFilters:boolean
  @Input() comparedFunds: string[] = []
  @Input() sortColumn = 'fundName'
  @Input() sortDirection = 'asc'
  @Input() numOfResults:any
  @Input() numAppliedFilters:number;
  @Input() isNonVanguard: boolean;
  @Input() NVGnumTotalResults:any
  @Input() numTotalResults:any
  @Input() isNvmf:any
  @Input() areAllFiltersEmpty: boolean
  openFilter=false
  buttonType="Open filters"
  ngOnInit(): void {
    this.PAGE_SIZE = PAGE_SIZE

    this.data$ = this.filtersService.filteredData$.pipe(
      catchError((err) => {
        console.log(err)
        this.isDataLoaded = false
        return throwError(err)
      }),
    )
    this.route.params.subscribe((params) => {
      this.disableSwitch = false
      if (params.accountingType !== undefined) {
        this.filterBy = params.accountingType
      } else {
        this.filterBy = 'all'
      }
      this.switchModel = false
      this.disableSwitch = this.filterBy !== 'etfs' && this.filterBy !== 'all'
    })

    this.route.queryParams.subscribe((params) => {
      if(params.filters==="open"){
        this.openFilter = true
        this.openFilterValue.emit(true)
        this.filtersService.openFilters=true;
        this.filtersService.applyFilters();
      }

    })
  }
  changeSortData(event) {
    this.sortColumn = event.sortColumn
    this.sortDirection = event.sortDirection
  }

    ngOnChanges() {
     if(this.closeFilters === true){
      this.openFilter= false
     }
    }

    ngAfterViewInit(){
      const redemptionFeeTickers = new Set(["VGRLX", "VGRNX", "VIAAX", "VIHAX"]);
      this.data$ = this.data$.pipe(
        map(data => {
          data?.fund?.entity?.forEach(fund => {
            if (redemptionFeeTickers.has(fund.profile.ticker)) {
              fund.fees.redemptionFee.content = "0.25%"
            }
          });
          return data;
        })
      )
    }

    get filtersLabel(): string {
      const count = this.numAppliedFilters ?? 0;
      return `Filters (${count})`;
    }

    openFilters(){
      if(this.openFilter===false){
          this.openFilter = true
          this.openFilterValue.emit(true)
          this.adobeLaunchService.subPageTabEvent(
            `${this.filterBy}:filters-action:button:open`,
          )
          this.filtersService.openFilters=true;
          this.filtersService.applyChangesToUrlParams({filters : "open"})
        } else{
          this.openFilter =false;
          this.openFilterValue.emit(false)
        }
    }

  setPage($event) {
    this.page = $event
  }
  changeTab($event) {
    this.activeTab = $event
  }
  resultTabChange(tab) {
    this.adobeLaunchService.callToAction(
      tab.concat(''),
      'Dynamic Funds List Page - Filter Section',
      'Tab',
    )
  }

  // eslint-disable-next-line complexity, max-statements
  getClass(){
    if(this.viewSwitch && !this.openFilter){
    return 'price-switch-container2';
    } else if (!this.viewSwitch){
    return 'price-switch-container';
    } else if (this.openFilter && this.viewSwitch){
    return 'price-switch-container3';
    }
  }

}
